export const APPOINTMENT_TYPES = {
  GENERATE_CERTIFICATE: 0,
}

export const APPOINTMENT_STATUS = {
  CANCELLED: 0,
  ACTIVE: 1,
}

export const APPOINTMENT_KEY_SLOTS = {
  ACTIVE: {
    key: 'a',
    value: "messages.appointment_active",
    short_value: "messages.appointment_active_short",
  },
  INACTIVE: {
    key: 'i',
    value: "messages.appointment_inactive",
    short_value: "messages.appointment_inactive_short",
  },
  RESERVED: {
    key: 'r',
    value: "messages.appointment_reserved",
    short_value: "messages.appointment_reserved_short",
  },
  RESERVED_BY_ANOTHER: {
    key: 'ra',
    value: "messages.appointment_inactive",
    short_value: "messages.appointment_inactive_short"
  },
}

export const APPOINTMENT_HOLIDAY_FILTERS = {
  'byDayAsTimestamp': 'byDayAsTimestamp',
};

export const APPOINTMENT_HOLIDAY_FILTERS_NAMES = {
  'byDayAsTimestamp': {
    ro: 'Data',
    en: 'Date',
  },
};
